module.exports = __webpack_public_path__ + "img/246e8fb1b3ec654f729e371b3ae2bf62.png";